import { REPUBS } from '@cx-modules/constants';

import { FOOTBALL } from './categoryGroupNames';

export const EVENT_DISPLAY_NAME = 'eventDisplayName';

export const EFL_CHAMPIONSHIP = 'EFL Champ';
export const EFL_LEAGUE_ONE = 'EFL L1';
export const EPL = 'EPL';

export const eventDisplayNames = {
	[REPUBS.OC.name]: {
		[EFL_CHAMPIONSHIP]: {
			displayName: 'Championship',
			categoryGroupName: FOOTBALL,
		},
		[EFL_LEAGUE_ONE]: {
			displayName: 'League One',
			categoryGroupName: FOOTBALL,
		},
		[EPL]: {
			displayName: 'Premier League',
			categoryGroupName: FOOTBALL,
		},
	},
	[REPUBS.US.name]: {
		[EFL_CHAMPIONSHIP]: {
			displayName: EFL_CHAMPIONSHIP,
			categoryGroupName: FOOTBALL,
		},
		[EFL_LEAGUE_ONE]: {
			displayName: EFL_LEAGUE_ONE,
			categoryGroupName: FOOTBALL,
		},
		[EPL]: {
			displayName: EPL,
			categoryGroupName: FOOTBALL,
		},
	},
};
